// src/redux/rentCorpApi.js
import { apiSlice } from "./apiSlice";

export const rentCorpApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 렌트카 법인 상세 조회
        getRentCorpDetail: build.query({
            query: (rentCorpId) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 차량 ID로 렌트 법인 조회
        getRentCorpByCarId: build.query({
            query: (carId) => ({
                url: `/api/user/rent_corp/v1/car/${carId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 법인 정보 수정
        updateRentCorp: build.mutation({
            query: ({ rentCorpId, body }) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 보험설정 정보 상세 조회
        getInsuranceConfigDetail: build.query({
            query: ({ rentCorpId, insuranceConfigId }) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/insurance_config/${insuranceConfigId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 보험설정 정보 수정
        updateInsuranceConfig: build.mutation({
            query: ({ rentCorpId, insuranceConfigId, body }) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/insurance_config/${insuranceConfigId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 보험설정 정보 삭제
        deleteInsuranceConfig: build.mutation({
            query: ({ rentCorpId, insuranceConfigId }) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/insurance_config/${insuranceConfigId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),

        // 사업자정보 등록: 로그인 후 최초 사업자정보 등록
        initRentCorpInfo: build.mutation({
            query: ({ rentCorpId, body }) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/init/info`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 활동 지역 상세조회
        getRentCorpAreaDetail: build.query({
            query: (rentCorpId) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/area`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 활동 지역 설정
        updateRentCorpArea: build.mutation({
            query: ({ rentCorpId, body }) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/area`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 렌트카 법인정보 수정
        changeRentCorpInfo: build.mutation({
            query: (body) => ({
                url: "/api/user/rent_corp/v1/change_info",
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 렌트카 업체 생성
        createRentCorp: build.mutation({
            query: (body) => ({
                url: "/api/user/rent_corp/v1",
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        // 보험설정 정보 리스트 조회
        getInsuranceConfigList: build.query({
            query: (rentCorpId) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/insurance_config`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 보험설정 정보 생성
        createInsuranceConfig: build.mutation({
            query: ({ rentCorpId, body }) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/insurance_config`,
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        // 지점리스트 조회
        getBranchInfo: build.query({
            query: (rentCorpId) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/branch`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 타 렌트카 업체 조회
        getSearchRentCorp: build.mutation({
            query: ({ query }) => ({
                url: "/api/user/rent_corp/v1/search",
                method: "get",
                headers: { token: true },
                params: { query, primary_yn: "Y" },
            }),
        }),

        // 나의 소속 렌트카 업체 조회
        getMyRentCorp: build.query({
            query: () => ({
                url: "/api/user/rent_corp/v1/me",
                method: "get",
                headers: { token: true },
            }),
        }),

        // 활동 지역 리스트 조회
        getRentCorpArea: build.query({
            query: () => ({
                url: "/api/user/rent_corp/v1/area",
                method: "get",
                headers: { token: true },
            }),
        }),

        // 메인 대표 회사 설정
        setRentCorpPrimary: build.mutation({
            query: (rentCorpId) => ({
                url: `/api/user/rent_corp/v1/${rentCorpId}/primary`,
                method: "put",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useGetRentCorpDetailQuery,
    useGetRentCorpByCarIdQuery,
    useLazyGetRentCorpByCarIdQuery,
    useUpdateRentCorpMutation,
    useGetInsuranceConfigDetailQuery,
    useUpdateInsuranceConfigMutation,
    useDeleteInsuranceConfigMutation,
    useInitRentCorpInfoMutation,
    useGetRentCorpAreaDetailQuery,
    useUpdateRentCorpAreaMutation,
    useChangeRentCorpInfoMutation,
    useCreateRentCorpMutation,
    useGetInsuranceConfigListQuery,
    useCreateInsuranceConfigMutation,
    useGetBranchInfoQuery,
    useGetSearchRentCorpMutation,
    useGetMyRentCorpQuery,
    useGetRentCorpAreaQuery,
    useSetRentCorpPrimaryMutation,
} = rentCorpApi;
